import { getInstance } from '../index';
import { saveAs } from 'file-saver';
import { downloadFile, apiBaseUrl } from '../../utilities/api/apiHelper';

class Policy {
  constructor() {
    this.axios = getInstance();
  }

  async getPolicyDetails(policyHolderId, adviserId) {
    const urlParams = adviserId ? `?adviserId=${adviserId}` : '';
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/policydetails/${policyHolderId}${urlParams}`
    );
  }

  async getPolicyDocument(policyNumber, documentId, fileName, adviserId) {
    let url = `${apiBaseUrl}/backendforfrontend/policydocuments/${policyNumber}/${documentId}`;
    url = !adviserId ? url : `${url}?adviserId=${adviserId}`;

    return downloadFile(this.axios, url, saveAs);
  }

  async getKeyFactsDocument(applicationId, coverType, quoteDate) {
    const url = `${apiBaseUrl}/backendforfrontend/${applicationId}/keyfacts/product/${coverType}/date/${quoteDate}`;
    const response = await this.axios.get(url);
    window.open(response.data.data.uri, '_blank');
  }
}

const poicy = new Policy(getInstance());
export default poicy;
